import { type Component } from 'solid-js'
import ProfileSectionCard from './ProfileSectionCard'

const AccountSettings: Component = () => {
  return (
    <div class="flex flex-wrap justify-center gap-8 w-full">
      <ProfileSectionCard />
    </div>
  )
}

export default AccountSettings
